<template>
    <v-navigation-drawer absolute left temporary v-model="drawer">

      <v-list
        dense
        nav
      >
        <slot name="menu"/>
        <v-divider></v-divider>
        <v-list-item @click="$router.replace('/decisions')">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Decisions
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link href="#" @click.prevent="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'
// Load the auth feature into the firebase namespace.
import 'firebase/auth'

import resetStore from '@/mixins/ResetStore.js'

export default {
  name: 'TopNavDrawer',
  mixins: [resetStore],
  props: {
    drawerOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentUser: firebase.auth().currentUser
    }
  },
  computed: {
    drawer: {
      // getter
      get: function () {
        return this.drawerOpen
      },
      // setter
      set: function (newValue) {
        this.$emit('onDrawerChanged', newValue)
      }
    }
  },
  methods: {
    logout: function () {
      this.resetAllStoreModules()
      firebase.auth().signOut().then(() => {
        this.$router.replace('/login')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.router-link-active {
  background: red;
}
</style>
